import dialogPolyfill from "dialog-polyfill";

export default () => {
	// Get modal element
	const modal = document.getElementById("search-modal");

	// If modal found...
	if (modal !== null) {
		// Register element with polyfill
		dialogPolyfill.registerDialog(modal);

		const activeClasses = ["overflow-y-hidden", "search-modal-open"];

		// Get close button on modal
		const closeBtn = document.getElementById("search-modal-close");

		// Event listener for close button
		closeBtn.addEventListener("click", () => {
			modal.close();
			for (const c of activeClasses) {
				document.body.classList.remove(c);
			}
		});

		// Loop through all elements that trigger the opening of the search modal...
		for (const item of document.querySelectorAll(
			"[data-search-modal-trigger]",
		)) {
			// Add click event listener to all triggers to open modal
			item.addEventListener("click", () => {
				for (const c of activeClasses) {
					document.body.classList.add(c);
				}
				modal.show();
			});
		}
	}
};
